{
	"maxTotal": "/ {{max}} total",
	"toastDecrease": "Decrease {{displayName}}: {{displayValue}}",
	"toastIncrease": "Increase {{displayName}}: {{displayValue}}",
	"toastModifyWithKeys": "Modify {{displayName}} with +/- Keys"
}
